import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-warn",
  "use": "icon-warn-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-warn\"><path d=\"M10 18.75a8.75 8.75 0 1 0-.001-17.501A8.75 8.75 0 0 0 10 18.75Zm.625-4.531c0 .086-.07.156-.156.156H9.53a.157.157 0 0 1-.156-.156V8.906c0-.086.07-.156.156-.156h.938c.086 0 .156.07.156.156v5.313ZM10 5.625A.938.938 0 0 1 10 7.5a.938.938 0 0 1 0-1.875Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol